import React, { Component } from 'react';
import axios from 'axios';
import auth0Client from '../../Auth';

import {SERVER_URL}  from '../../Constants';

import {ToastContainer, ToastStore} from 'react-toasts';
import CheckInTransfer from '../../Warehouse/CheckInTransfer';
import Modal from 'react-responsive-modal';
import DatePicker from "react-datepicker";

export default class Actions extends Component {
    constructor(props) {
      super(props);
      this.state = 
        { 
           numItems :0,
           selectedItems:[],
           displayDonateDisposeModal:false,
           displayCheckInTransfer: false,
           donateDisposeDate:new Date(),
           donateDisposeNote:'',
           //donateDisposeDate:undefined,     
           checkInTransferMode:1,
           checkInLocations:[],
           checkInLocationFilter : '',
           idsToProcess:[],
           title:'',
           processingTitle:'',
           dispositionVendors:[],
           dispositionVendorId:'',
           returnedToStaffName:'',
           displayReturnToStaff:false
           
        };
  
      // calculate stats when new rows loaded, i.e. onModelUpdated
      this.props.api.addEventListener(
        'rowSelected',
        this.updateSelectedItem.bind(this)
      );
     
  
    }
    async componentDidMount() {
      try {
        let venue=  auth0Client.getDefaultVenue();
           
        // set venueTypeCode
        this.setState({
          venueTypeCd: venue.venueTypeCd,
          enableWarehouse:venue.enableWarehouse,
          displayQueryLayout: false,//(venueTypeCd==='A'),
        })
      
        //this.loadCheckInLocationsForStorage();
        this.loadDispositionVendors();
  
        }
          catch(e){
            ToastStore.error(e.message);
          }
      
  
      
   
    }
    updateSelectedItem() {


        let selectedRows=  this.props.api.getSelectedRows();
        if (selectedRows){
            // get the IDS to transfer
            let idsToProcess = [];
            let numChecked = selectedRows.length;
            for (var i=0; i<numChecked; i++){
              let id = selectedRows[i]._id;
              if (id) {
                idsToProcess.push(id);
              }
          
            }
            this.setState({
                numItems : selectedRows.length,
                selectedItems:selectedRows,
                idsToProcess:idsToProcess
            })
        }else{
            this.setState({
              numItems : 0,
              selectedItems:[],
              idsToProcess:[]
          })
        }
        
      
        /* this.props.api.forEachNode((rowNode) => {
          const data = rowNode.data;
    
        });
    
        */
    }


    dispose=()=>{
        // Check count and confirm
        this.setState({changeCd:'T', title:'Dispose'});
      if (this.state.selectedItems && this.state.selectedItems.length===0){
          // nothing to process here
          alert('Please select items to process first');
          return;
      }
     

      console.log(this.state.selectedItems);

      this.setState({displayDonateDisposeModal:true});
    }

    donate=()=>{
      // Check count and confirm
      this.setState({changeCd:'D', title:'Donate'});
    if (this.state.selectedItems && this.state.selectedItems.length===0){
        // nothing to process here
        alert('Please select items to process first');
        return;
    }
   
    this.setState({displayDonateDisposeModal:true});


  }

  archive=()=>{
    // Check count and confirm
    this.setState({changeCd:'A', title:'Archive'});
    if (this.state.selectedItems && this.state.selectedItems.length===0){
        // nothing to process here
        alert('Please select items to process first');
        return;
    }
   this.setState({displayDonateDisposeModal:true});


}
moveToInventory=()=>{
  // Check count and confirm
  this.setState({changeCd:'Q', title:'Inventory'});
  if (this.state.selectedItems && this.state.selectedItems.length===0){
      // nothing to process here
      alert('Please select items to process first');
      return;
  }
 this.setState({displayDonateDisposeModal:true});


}
returnToStaff=()=>{
  this.setState({changeCd:'R', title:'Return To Staff'});
  if (this.state.selectedItems && this.state.selectedItems.length===0){
      // nothing to process here
      alert('Please select items to process first');
      return;
  }
 this.setState({displayReturnToStaff:true});
}


  transfer=()=>{
  


     // Check count and confirm
     this.setState({changeCd:'CHK'});
     if (this.state.idsToProcess && this.state.idsToProcess.length===0){
         // nothing to process here
         alert('Please select items to process first');
         return;
     }

    this.setState({checkInTransferMode:1, displayCheckInTransfer:true});
  }
      // Chang in this should add another filter to the filtered results
  handleInputStorageChange=(event) =>{
    const target = event.target;
    const value = target.value;
   
    //const name = target.name;

    this.setState({
      checkInLocationFilter : value,
     
    }, ()=>{
      this.applyAllFilters()
    });
  }

  // Loads the check in locations for the storage selection list.  Warehouse accounts
    // can only select from a specific list.
    loadCheckInLocationsForStorage=async()=>{

      try{
          const checkInLocations = (await axios.post(`${SERVER_URL}/CheckInOut/CheckInLocations`,{}, {
          headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
          this.setState({checkInLocations:checkInLocations})

      }catch(e){
        this.setState({checkInLocations:[]})
      }
        
    }
    loadDispositionVendors=async()=>{

      try{
          const resultsDTO = (
            await axios.get(`${SERVER_URL}/dispo/vendors`,{
                  headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }
                })).data;
          if (resultsDTO.items){
            this.setState({dispositionVendors:resultsDTO.items})
          }
          
          

      }catch(e){
        this.setState({dispositionVendors:[]})
      }
        
    }

    onCheckInTransferCompleted=(itemsUpdated)=>{
      // Reload everything
      // change the slected index of action dropdown
      this.setState({displayCheckInTransfer:false})  
      if(this.props.batchProcessComplete){this.props.batchProcessComplete()}

  }

  handleInputChange=(event) =>{
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });
  }
  onReturnedDonateDisposeDateChanged= date => this.setState({ donateDisposeDate:date });

  batchUpdateDontateDisposed=()=>{

    if (this.state.donateDisposeDate===undefined){
      alert('Please enter a valid date');
      return;
    }
    let numChecked = this.state.idsToProcess.length;
 
    let confirmMsg ='';
    if (this.state.changeCd!==undefined && this.state.changeCd!=='' ){
      switch (this.state.changeCd){
        case 'A' : confirmMsg = 'Your about to archive ' + numChecked + ' items. Ok to continue?';  break;
        case 'D' : confirmMsg = 'Your about to donate ' + numChecked + ' items. Ok to continue?'; break;
        case 'T' : confirmMsg = 'Your about to dispose ' + numChecked + ' items. Ok to continue?';  break;
        case 'R' : confirmMsg = 'Your about to return ' + numChecked + ' to the assigned staff. Ok to continue?';  break;
   
        case 'Q' : confirmMsg = 'Your about to move ' + numChecked + ' items back to the inventory. Ok to continue?';  break;
        default:confirmMsg='';
      }
     // this.setState({displayDonateDisposeModal:false});
     // console.log(this.state.idsToProcess);
      if (confirmMsg && window.confirm(confirmMsg)){
        this.batchUpdate(this.state.idsToProcess, this.state.changeCd);
      }

    }
    
    
  
  }
    // ****************************************   batch update  ****************************************
    //
    //**************************************************************************************************
    batchUpdate=(ids, newStatusCd)=>{
      //  console.log('loading...' + auth0Client.getIdToken());
      
      if (ids.length<=0){
        alert('no items selected');
      }
      if (newStatusCd==='' || newStatusCd===undefined){
        alert('No status selected for batch update');
      }
      this.setState({processingTitle:'Running Batch Update...Please Wait'});
      axios.post(SERVER_URL +  '/dispo/RunBatch',{
        ids:ids,
        statusCd:newStatusCd,
        returnedToStaffName:this.state.returnedToStaffName,
        donateDisposeNote: this.state.donateDisposeNote,
        donateDisposeDate: this.state.donateDisposeDate,
        isGreenflag: false,
        dispositionVendorId:this.state.dispositionVendorId,
        isReturnedToStaff: (newStatusCd==='R')
      }, 
      {
        headers: { 
          'Authorization': `Bearer ${auth0Client.getIdToken()}`,
          'venueId': auth0Client.getActiveVenuedId() 
        }
      }).then((res)=>{
        
        if (res.status !== 200) {
          //place your reentry code
          //console.log(res);
          ToastStore.error("An error occured. Please try again :" + res.body);
        
        }else{
          ToastStore.success('Batch update completed successfully!');
          this.setState({donateDisposeNote:'', donateDisposeDate:undefined, displayDonateDisposeModal:false, displayReturnToStaff:false, displayCheckInTransfer:false});
          if(this.props.batchProcessComplete){this.props.batchProcessComplete()}
        }

        this.setState({processingTitle:''});
        // reload
        

        }).catch((e)=>{ 
          //console.log("error " + e)
          ToastStore.error("An error occured. " + e.message);
          this.setState({processingTitle:''});
        });

    }


    renderDisposeDonateDetailsModal=()=>{
      return (
        <Modal open={this.state.displayDonateDisposeModal} onClose={()=>this.setState({displayDonateDisposeModal:false})} center>
            <div style={{width:'500px', height:'500px'}}>
              <h4>Batch Upate: {this.state.title}</h4>
              <small>Each record will be assigned the following date and note:</small>
              <br/><br/>
              <label htmlFor="donateDisposeDate" className='text-danger'><b>Date:</b></label>
                                  <br/>
                                    <DatePicker
                                    className="form-control"
                                      onChange={this.onReturnedDonateDisposeDateChanged}
                                      name="donateDisposeDate"
                                      selected={this.state.donateDisposeDate}
                                    />             
                                
                  <br/>         
              <label htmlFor="donateDisposeNote" className='text-primary'><b>Note:</b></label>
                            <input
                                                disabled={this.state.disabled}
                                                type="text"
                                                onChange={this.handleInputChange}
                                                name="donateDisposeNote"
                                                className="form-control"
                                                placeholder=""
                                                value= {this.state.donateDisposeNote}
                                              />
                <br/>
             
             
                     <label htmlFor="dispositionVendorId" className='text-primary'> Vendor:</label>
            

              
                   <select 
                        className="custom-select"
                        type="text"
                        name="dispositionVendorId"
                        onChange={this.handleInputChange}
                        value={this.state.dispositionVendorId}
                    >   
                      <option value=""></option>
                        {this.state.dispositionVendors.map(item=>{
                            return (
                                <option value={item._id}>{ item.vendorName }</option>
                            )
                        })}
                   </select>
              
          
         
                <div className='row'>
                  <div className='col text-center'>
                  <label className='text-warning'><b>{this.state.processingTitle}</b></label>
                  </div>
                </div>
  
  
            </div>
            <button
              disabled={this.state.disabled || auth0Client.lfReadOnly===true}
              className="btn btn-success text-center"
              onClick={() => {this.batchUpdateDontateDisposed()}}>
                  Run Batch Update
            </button>
      </Modal>  
      )
    }

    renderReturnToStaff =()=>{

      return(
        <Modal open={this.state.displayReturnToStaff} onClose={()=>this.setState({displayReturnToStaff:false})} center>
        <div style={{width:'500px', height:'500px'}}>
          <h5>Return To Staff:</h5>
          <small>Each record will be assigned the following:</small>
          <br/><br/>
          <label htmlFor="donateDisposeDate" className='text-danger'><b>Date:</b></label>
                              <br/>
                                <DatePicker
                                autoComplete="off"
                                className="form-control"
                                  onChange={this.onReturnedDonateDisposeDateChanged}
                                  name="donateDisposeDate"
                                  selected={this.state.donateDisposeDate}
                                />             
                            
              <br/>         
          <label htmlFor="donateDisposeNote" className='text-primary'><b>Note:</b></label>
                        <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="donateDisposeNote"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.donateDisposeNote}
                                          />
            <br/>
            <label htmlFor="returnedToStaffName" className='text-primary'><b>Employee Name:</b></label>
                        <input
                                            disabled={this.state.disabled}
                                            type="text"
                                            onChange={this.handleInputChange}
                                            name="returnedToStaffName"
                                            className="form-control"
                                            placeholder=""
                                            value= {this.state.returnedToStaffName}
                                          />
            <br/>
           
            


        </div>
        <button
          disabled={this.state.disabled}
          className="btn btn-success"
          onClick={() => {this.batchUpdateDontateDisposed()}}>
              Run Batch Update
        </button>
  </Modal>  
      )
   
    }

    renderCheckInTransfer =()=>{

      return(
        <Modal style={{width:250, height:250}} open={this.state.displayCheckInTransfer} onClose={()=>this.setState({displayCheckInTransfer:false})} center>
                  <CheckInTransfer selectedItems={this.state.idsToProcess} mode={this.state.checkInTransferMode}  
                                  onCheckInTransferCompleted={this.onCheckInTransferCompleted.bind(this)} 
                                  onClose={()=>this.setState({displayCheckInTransfer:false})} 
                                  >
                                  
                  </CheckInTransfer>
        </Modal>
      )
  
  
    }

    export=()=>{
      if(this.props.export){this.props.export()}
    }
    print=()=>{
      if(this.props.print){this.props.print()}
    }

    render() {
  

        return (
          <div  className='container' style={{backgroundColor:'white',width:250}}>
            <br/>
                    <div className='col text-primary text-center'><h5>Actions</h5></div>
                    <br/>
                    <div className='col text-secondary text-center'><h6> {this.state.numItems} selected</h6></div>
            <br/><br/>
            <hr/>
            <div className='row'>
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                        <button className="btn btn-primary " style={{width:190}} id="optArchive" onClick={this.dispose} >Dispose</button>
                </div>

            </div>
            <br/><br/>
            <div className='row'>
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                        <button className="btn btn-success " style={{width:190}} id="optArchive" onClick={this.donate} >Donate</button>
                </div>

            </div>
            <br/><br/>
            <div className='row'>
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                        <button className="btn btn-info " style={{width:190}} id="optArchive" onClick={this.transfer} >Transfer</button>
                </div>
            </div>        

            <br/>
            <hr/>
            <div className='row'>
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                        <button className="btn btn-outline-primary " style={{width:190}} id="optArchive" onClick={this.archive} >Archive</button>
                </div>
            </div>  
            <br/>
            <div className='row'>
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                        <button className="btn btn-outline-success " style={{width:190}} id="optArchive" onClick={this.moveToInventory} >Move To Inventory</button>
                </div>
            </div>   
            <br/><hr/> 
            <div className='row'>
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                        <button className="btn btn-outline-warning " style={{width:190}} id="optArchive" onClick={this.returnToStaff} >Return To Staff</button>
                </div>
            </div>  
            <br/>

             <br/><hr/>
             <div className='row'> 
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                    <button className="btn  btn-link"  id="optArchive" onClick={this.export} >Export (csv)</button>
                </div>  
            </div>  
            {
              
              /*<div className='row'> 
                <div className='col text-center'  style={{backgroundColor:'white'}}>
                    <button className="btn  btn-link"  id="optArchive" onClick={this.print} >Print</button>
                </div>  
            </div>   */
    } 
                      <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
                      {this.renderDisposeDonateDetailsModal()}
                      {this.renderCheckInTransfer()}
                      {this.renderReturnToStaff()}

          </div>
        );
      }
}

